<template>
  <div class="grantlist">
    <header>
      <div class="header_sonbox">欢迎使用中资云企业综合服务平台</div>
    </header>
    <main>
      <div class="titleBox">
        <div class="titleBox_left">
          <img src="../assets/imgs/home/logo2.png" alt />
          <span>{{pageTitle}}</span>
        </div>
        <div class="titleBox_right">
          <span @click="goHome">平台首页</span>
        </div>
      </div>
      <div class="backBox" style="width: 70px;cursor: pointer;">
        <Icon type="ios-arrow-back" />
        <span @click="back">返回</span>
      </div>
      <div class="mainBox">
        <div class="main_title">{{pageTitle}}</div>
        <div class="successBox" v-show="show == 1">
          <div class="successBox_titleson">
            <img src="../assets/image/success.png" alt="">
            <span>{{pageTitle}}提交成功！</span>
          </div>
          <div class="successBox_messageson"><span>平台审核通过才能发放调运单，请耐心等待。</span></div>
          <div class="threeBox">{{time}} 秒后自动跳转</div>
          <div class="returnBox">
            <Button style="background-image: linear-gradient(180deg, rgba(255,255,255,0.97) 0%, rgba(251,251,251,0.98) 37%, #F5F5F5 100%);
border: 1px solid #D8D8D8;width: 114px;height: 34px;" @click="goBack">返回</Button>
          </div>
        </div>
        <div class="formBox" v-show="show == 0">
          <Form ref="formInline" :model="formItem" :rules="ruleInline" label-position="top">
            <div class="flex-between-center">
              <FormItem label="预申报编号" style="width: 40%;" prop="contractNo">
                <Input style="width: 100%;" disabled type="text" v-model="formItem.contractNo" placeholder="请输入预申报编号"></Input>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
              <FormItem label="交易矿种" style="width: 40%;" prop="oreId">
                <Select v-model="formItem.oreId" placeholder="请选择交易矿种">
                  <Option v-for="item in kuangArr" :value="item.oreId?item.oreId:''" :key="item.oreId">{{item.oreName}}
                  </Option>
                </Select>
                <div class="titleColor">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="申报量(吨)" prop="contNum" style="width: 40%;">
                <Input style="width: 100%;" type="text" v-model="formItem.contNum" placeholder="请输入申报量(吨)"></Input>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
              <FormItem label="成交价(元/吨)" prop="orePrice" style="width: 40%;">
                <Input style="width: 100%;" type="text" v-model="formItem.orePrice" placeholder="请输入成交价(元/吨)"></Input>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="调运企业" prop="orgName" style="width: 40%;">
                <Input style="width: 100%;" type="text" v-model="session.enterpriseName" disabled></Input>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
              <FormItem label="需方企业" prop="buyer" style="width: 40%;">
                <Input style="width: 100%;" type="text" @on-focus="onFocus" @on-change="inputKey" @on-blur="onBlur" v-model="formItem.buyer" placeholder="请输入需方企业">
                </Input>
                <div style="position: relative;">
                  <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
                  <div class="toastBox" :style="{display:onfocus}">
                    <div v-if="companyList.length>0">
                      <p v-for="(item,i) in companyList" @click="selectCompany(item.ENTERPRISE_NAME,item.ENTERPRISE_CODE)" :key="i">{{item.ENTERPRISE_NAME}}</p>
                    </div>
                    <p v-if="companyList<=0">暂无数据</p>
                  </div>
                </div>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="装运地" prop="startDir" style="width: 40%;" :show-message="false">
                <Input style="width: 100%;" type="text" v-model="formItem.startDir" placeholder="请输入装运地"></Input>
                <div class="titleColor">*若存在多个装运地请用“/”隔开</div>
                </FormItem`>
                <FormItem label="目的地" prop="endDir" style="width: 40%;" :show-message="false">
                  <Input style="width: 100%;" type="text" v-model="formItem.endDir" placeholder="请输入目的地"></Input>
                  <div class="titleColor">*若存在多个目的地请用“/”隔开</div>
                </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="执行日期" prop="executeDate" style="width: 40%;">
                <DatePicker type="daterange" v-model="formItem.executeDate" :start-date="new Date()" placement="bottom-end" placeholder="请输入执行日期" style="width: 100%"></DatePicker>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
            </div>
            <div>
              <FormItem label="质量要求" style="width: 100%;">
                <Input v-model="formItem.qrDescribe" type="textarea" :rows="5" placeholder="请输入质量要求"></Input>
                <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div>
              </FormItem>
            </div>
            <div class="contractBox">
              <span style="color: red;margin-right: 8px;font-size: 15px;">*</span>
              <span style="font-size: 14px;color: #B3B8C4;position: relative;top: -3px;">合同照片</span>
              <Button style='background-image: linear-gradient(180deg, #B4EC51 0%, #429321 100%);border: 1px solid #4C9B25;border-radius: 4px;color: white;width: 117px;height: 26px;margin-left: 16.5px;margin-bottom: 8px;' @click="showModal2">手机上传</Button>
              <Modal v-model="modal2" width="480" class-name="vertical-center-modal">
                <p slot="header" style="text-align:center">
                  <span style="color: white;font-size: 18px;font-weight: 600;">手机上传</span>
                </p>
                <div style="justify-content: center;display: flex;">
                  <div ref="qrcodeDiv">
                  </div>
                </div>
                <div slot="footer" style="text-align:center">
                  <span>微信扫描二维码上传照片</span>
                </div>
              </Modal>
              <Upload :action="this.$baseUrl" :before-upload="handleUpload">
                <Button style='background-image: linear-gradient(180deg, #5792E3 0%, #406DD8 100%);border: 1px solid #285ED3;border-radius: 4px;color: white;width: 117px;height: 26px;margin-left: 16.5px;'>本地上传</Button>
              </Upload>
              <span style="margin-left: 16.5px;margin-bottom: 8px;color: #2C59C3;font-size: 12px;">共{{imgArr.length}}张照片</span>
            </div>
            <div class="photoBox">
              <div class="photoBox_son1" v-show="imgArr.length<=0">
                合同照片
              </div>
              <div class="photoBox_son2" v-show="imgArr.length>0">
                <div class="imgBox">
                  <div class="imgbg" v-for="(item,i) in imgArr" :key="i">
                    <img class="imgbg_img" :src="fileCommonUrl + item" alt="">
                    <img @click="gobig(fileCommonUrl + item)" style="position: absolute;top: 140px;left: 100px;cursor: pointer;" src="../assets/image/gobig.png" alt="">
                    <img @click="goremove(i)" style="position: absolute;top: 140px;left: 130px;cursor: pointer;" src="../assets/image/goremove.png" alt="">
                  </div>
                </div>
              </div>
              <div class="goPrev" @click="goPrev" v-if="imgArr.length>4">
                <Icon size="25" :color="index<=0?'':'#5086E0'" type="ios-arrow-dropleft" />
              </div>
              <div class="goNext" @click="goNext" v-if="imgArr.length>4">
                <Icon size="25" :color="(imgArr.length - 4) > index?'#5086E0':''" type="ios-arrow-dropright" />
              </div>
            </div>
            <div class="hint" style="margin-bottom: 30px;font-size: 14px;color: #B3B8C4;">
              支持JPG、 JPEG、PNG格式，大小不超过2M
            </div>
            <div class="submitBox" @click="submit('formInline')">
              调运申报
            </div>
            <Modal v-model="modal" width="720" class-name="vertical-center-modal">
              <p slot="header" style="text-align:center;">
                <span style="color: white;font-size: 18px;font-weight: 600;">{{pageTitle}}确认</span>
              </p>
              <div>
                <div class="tabListBox">
                  <div :class="{'bgColor':isActive == i}" v-for="(item,i) in tabList" @click="isActive = i" :key="i">
                    {{item}}
                  </div>
                </div>
                <div v-if="isActive == 0">
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">预申报编号</span>
                      </div>
                      <div class="renderbox">{{formItem.contractNo}}</div>
                    </div>
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">交易矿种</span>
                      </div>
                      <div class="renderbox">{{formItem.oreName}}</div>
                    </div>
                  </div>
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">申报量（吨）</span></div>
                      <div class="renderbox">{{formItem.contNum}}</div>
                    </div>
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">成交价（元/吨）</span></div>
                      <div class="renderbox">{{formItem.orePrice}}</div>
                    </div>
                  </div>
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">调运企业</span>
                      </div>
                      <div class="renderbox">{{session.enterpriseName}}</div>
                    </div>
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">需方企业</span>
                      </div>
                      <div class="renderbox">{{formItem.buyer}}</div>
                    </div>
                  </div>
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">装运地</span>
                      </div>
                      <div class="renderbox">{{formItem.startDir}}</div>
                    </div>
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">目的地</span>
                      </div>
                      <div class="renderbox">{{formItem.endDir}}</div>
                    </div>
                  </div>
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div style="width: 40%;">
                      <div style="margin: 10px 0;"><span class="star">*</span><span style="color: #9CA2B2;">执行日期</span>
                      </div>
                      <div class="renderbox">{{formItem.setStartDate}} - {{formItem.setEndDate}}</div>
                    </div>
                  </div>
                  <div style="width: 100%;">
                    <div>
                      <div style="margin: 10px 0;"><span style="color: #9CA2B2;">质量要求</span>
                      </div>
                      <div class="renderbox" style="height: 92px;">{{formItem.qrDescribe}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="isActive == 1">
                  <div style="display: flex;align-items: center;margin: 20px auto;width: 80%;justify-content: center;">
                    <div @click="goPrevModal">
                      <Icon size="40" :color="indexModal==0?'':'#5086E0'" type="ios-arrow-dropleft" />
                    </div>
                    <div style="width: 318px;height: 518px; overflow: hidden;">
                      <div class="son" style="display: flex;transition: transform 0.35s;">
                        <div v-for="item in imgArr" :key="item.i" style="width: 318px;height: 518px;text-align: center;line-height: 518px;flex-shrink: 0;position: relative;">
                          <img style="width: 300px;height: 95%;" :src="fileCommonUrl + item" alt="">
                        </div>
                      </div>
                    </div>
                    <div @click="goNextModal">
                      <Icon size="40" :color="(imgArr.length - 1) > indexModal?'#5086E0':''" type="ios-arrow-dropright" />
                    </div>
                  </div>
                </div>
                <div style="border: 1px dashed #E5E5E5;margin: 20px 0;"></div>
                <div style="color: #9CA2B2;">申报预计税费</div>
                <div style="font-size: 30px;color: #D0021B;">{{(formItem.contNum * taxSumMoney).toFixed(2)}}</div>
              </div>
              <div slot="footer">
                <div style="display: flex;justify-content: center;">
                  <Button style="width: 138px;" @click="modal = false">取消</Button>
                  <Button style="width: 138px;background-image: linear-gradient(180deg, #478EE9 0%, #2255CE 100%);color: white;" :loading="modal_loading" @click="submit2">提交</Button>
                </div>
              </div>
            </Modal>
          </Form>
        </div>
      </div>
    </main>
    <foot></foot>
    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
  </div>
</template>

<script>
import foot from '../components/footer.vue';
import QRCode from 'qrcodejs2';
import vueViewer from '../components/bigImg/Viewer.vue';
import { mapState, mapMutations, mapActions } from "vuex";
let companyArr = [];
let timeId;
export default {
  data () {
    var validate = function (rule, value, callback) {
      if (Array.isArray(value)) { //格式为：daterange、datetimerange检测
        value.map(function (item) {
          if (item === "") {
            return callback("日期不能为空")
          }
        })
      } else { //格式为：date、datetime、year、month 检测
        if (value === '') {
          return callback("日期不能为空")
        }
      }
      return callback()
    }
    return {
      onfocus: 'none',
      companyCode: '',
      pageTitle: '新增预申报',
      isShowBig: false,
      bigUrl: [],
      tabList: ['申报信息', '合同照片'],
      companyList: [],
      model11: '',
      formItem: {
        contractNo: '', //预申报编号
        oreId: '', //交易矿种
        contNum: '', //申报量
        orePrice: '', //矿种单价
        enterpriseId: '', //调运企业
        buyer: '', //需方企业
        startDir: '', //装运地
        endDir: '', //目的地
        executeDate: [], //执行日期
        qrDescribe: '', //质量要求			
        taxSum: '',
        contPrice: '',
        imgArr: [],
        buyerId: ''
      },
      ruleInline: {
        contractNo: [{
          contractNo: true,
          trigger: 'blur'
        }],
        oreId: [{
          required: true,
          trigger: 'change',
          message: ' '
          // message: '*请仔细确认预申报矿种信息，避免错误给您带来不便'
        },],
        contNum: [{
          required: true,
          trigger: 'blur',
          message: ' '
        },],
        orePrice: [{
          required: true,
          trigger: 'blur',
          message: ' '
        },],
        enterpriseId: [{
          required: true,
          trigger: 'blur',
          message: ' '
        },],
        buyer: [{
          required: true,
          trigger: 'change',
          message: ' '
        },],
        startDir: [{
          required: true,
          trigger: 'blur',
          // message: ''
        },],
        endDir: [{
          required: true,
          trigger: 'blur',
          // message: '*若存在多个目的地请用“/”隔开'
        },],
        executeDate: [{
          required: true,
          validator: validate,
          trigger: 'change'
        }]
      },
      index: 0,
      indexModal: 0,
      modal: false,
      modal2: false,
      isActive: 0,
      modal_loading: false,
      show: 0,
      time: 3,
      session: '',
      imgArr: [],
      kuangArr: [],
      company: '',
      taxSumMoney: '',
      fileCommonUrl: '',
      websock: null,
      lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      websockHeart: true,
    }
  },
  components: {
    foot,
    vueViewer
  },
  destroyed () {
    var self = this;
    self.timeoutObj && clearTimeout(self.timeoutObj);
    self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
    this.websockHeart = false
  },
  methods: {
    ...mapMutations(["setContentType", "setMenuName",]),
    onFocus () {
      this.onfocus = 'block';
    },
    onBlur () {
      setTimeout(() => {
        this.onfocus = 'none';
      }, 200)
    },
    selectCompany (name, code) {
      this.formItem.buyer = name;
    },
    goHome () {
      window.sessionStorage.removeItem('from');
      this.setContentType(0);
      this.$router.push("/home");
    },
    goBack () {
      clearInterval(timeId)
      window.sessionStorage.setItem('from', 'grantList');
      this.$router.push("/home");
    },
    goNext: function () {
      let imgbox = document.querySelector(".imgBox");
      if ((this.index + 4) == this.imgArr.length) {
        return
      }
      this.index += 1
      let s = this.index * 240
      imgbox.style.transform = 'translate(' + -s + 'px' + ')';
    },
    goPrev: function () {
      let imgbox = document.querySelector(".imgBox");
      if (this.index == 0) {
        return
      }
      this.index -= 1
      let s = this.index * 240
      imgbox.style.transform = 'translate(' + -s + 'px' + ')';
    },
    goNextModal: function () {
      let son = document.querySelector(".son");
      if ((this.indexModal + 1) == this.imgArr.length) {
        return
      }
      this.indexModal += 1
      let s = this.indexModal * 318
      son.style.transform = 'translate(' + -s + 'px' + ')';
    },
    goPrevModal: function () {
      let son = document.querySelector(".son");
      if (this.indexModal == 0) {
        return
      }
      this.indexModal -= 1
      let s = this.indexModal * 318
      son.style.transform = 'translate(' + -s + 'px' + ')';
    },
    gobig: function (url) {
      if (this.bigUrl.length != 0) {
        this.bigUrl = [];
      }
      this.isShowBig = true;
      this.bigUrl.push(url);
    },
    goremove: function (i) {
      this.imgArr.splice(i, 1);
      this.formItem.imgArr.splice(i, 1);
    },
    submit: function (name) {
      if (this.imgArr.length > 0) {
        this.formItem.imgPaths = this.imgArr.join(',')
      } else {
        // this.$Message.error('请上传合同照片');
        return
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          let info;
          // 判断选中的矿种有没有税率
          this.kuangArr.forEach(ele => {
            if (ele.oreId == this.formItem.oreId) {
              info = ele;
              this.taxSumMoney = ele.taxSumMoney;
            }
          });
          if (info.taxSumMoney) {
            // this.step = 2;
            this.formItem.setStartDate = this.$timeChange(this.formItem.executeDate[0]);
            this.formItem.setEndDate = this.$timeChange(this.formItem.executeDate[1]);
            this.kuangArr.forEach(item => {
              if (item.oreId == this.formItem.oreId) {
                this.formItem.oreName = item.oreName
              }
            })
            this.modal = true;
          } else {
            this.$Message['error']({
              background: true,
              content: "该矿种没设置税率,请联系市县工作人员设置税率！"
            });
          }
        }
      })
    },
    submit2: function () {
      this.modal_loading = true;
      this.formItem.imgPaths = this.imgArr.join(',')
      // 如果选择的需方企业传ID，负责传输入的名字
      companyArr.forEach((item) => {
        if (item.ENTERPRISE_NAME == this.formItem.buyer) {
          // this.formItem.buyer = item.ENTERPRISE_CODE;
          this.formItem.buyerId = item.ID;
        }
      })
      if (this.pageTitle == '新增预申报') {
        let data = {
          ...this.formItem,
          taxSum: (this.formItem.contNum * this.taxSumMoney).toFixed(2),
          contPrice: (this.formItem.contNum * this.formItem.orePrice).toFixed(2),
          modeCode: '3DoBT4d0rvxuHcNFT4NvIwNbQrHuhYWf',
          sessionId: this.session.sessionId
        }
        this.$http.post(data)
          .then(res => {
            this.modal_loading = false;
            if (res.code == 1) {
              this.modal = false;
              this.show = 1;
              this.timeChange();
            } else {
              this.$Message.error('新增失败，请重试!');
            }
          })
      } else if (this.pageTitle == '编辑预申报') {
        let data = {
          ...this.formItem,
          taxSum: (this.formItem.contNum * this.taxSumMoney).toFixed(2),
          contPrice: (this.formItem.contNum * this.formItem.orePrice).toFixed(2),
          modeCode: 'fGlwswq5DQOm6CnOYEhVAi0XeJeIy9GG',
          sessionId: this.session.sessionId
        }
        this.$http.post(data)
          .then(res => {
            this.modal_loading = false;
            if (res.code == 1) {
              this.modal = false;
              this.show = 1;
              this.timeChange();
            } else {
              this.$Message.error('编辑失败，请重试!');
            }
          })
      }
    },
    timeChange: function () {
      timeId = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          window.history.back(-1);
          clearInterval(timeId)
        }
      }, 1000)
    },
    back () {
      clearInterval(timeId)
      this.$router.go(-1)
      this.setContentType(12)
      this.setMenuName(window.localStorage.getItem('fid'))
    },
    showModal2: function () {
      this.modal2 = true;
      function getUUID () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
          return (c === "x" ?
            (Math.random() * 16) | 0 :
            "r&0x3" | "0x8"
          ).toString(16);
        });
      }
      let uuid = getUUID();
      setTimeout(() => {
        this.$refs.qrcodeDiv.innerHTML = ""
        var that = this;
        let href = localStorage.getItem("platUrl") + '/#/' + 'upload?' + that.session.sessionId + '&' + that.session.userId
        var qrcode = new QRCode(this.$refs.qrcodeDiv, {
          text: href, //二维码内容   url填后台给的链接         
          width: 270, //控制二维码高度             
          height: 270, //控制二维码宽度           
          colorDark: "#000000", //控制二维码前景色           
          colorLight: "#ffffff", //控制二维码背景色
          correctLevel: QRCode.CorrectLevel.L //设置二维码容错率       
        });
      }, 100)
    },
    // 获取预申报编号
    getGrantListNo: function () {
      let data = {
        sessionId: this.session.sessionId,
        modeCode: 'MOw3Am6E4O1LDJ4ph3Qa4BJUKP2EfQ6F'
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.formItem.contractNo = res.data.contractno;
          }
        })
    },
    // 查询需方企业
    inquireEnterprise: function (key) {
      let data = {
        sessionId: this.session.sessionId,
        modeCode: 'Il9LhbAju1Qa9XCqFEb6CPSTFnxJxWwR',
        enterpriseId: this.session.enterpriseId,
        keyword: key || ''
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.companyList = res.data;
            companyArr = res.data;
          }
        })
    },
    //需方企业输入事件
    inputKey: function (key) {
      this.inquireEnterprise(key.data);
    },
    // 获取矿种
    getKuangArr: function () {
      let data = {
        sessionId: this.session.sessionId,
        modeCode: 'NEKPI3BNTyQIj9lRgMmZI9jzmhrp3vjJ',
        userId: this.session.userId
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.kuangArr = res.data;
          }
        })
    },
    handleUpload (file) {
      const msg = this.$Message.loading({
        content: "上传中...",
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: "DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M",
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: "other", //其他分组
        };
        let base64 = encodeURIComponent(file64);
        this.$http.upload(data, base64)
          .then(res => {
            setTimeout(msg, 300);
            if (res.code == 1) {
              this.imgArr.push(res.msg);
              this.formItem.imgArr.push(res.msg);
            } else {
              this.$Message['error']({
                background: true,
                content: '上传失败，请重试'
              });
            }
          })
      }
      return false;
    },
    // websock链接
    init () {
      let url = localStorage.getItem("uploadFileSocketUrl") + '/' + this.session.sessionId // 创建websocket连接
      this.websock = new WebSocket(url); // 监听打开
      this.websock.onopen = this.websockOpen; // 监听关闭
      this.websock.onclose = this.websockClose; //监听异常
      this.websock.onerror = this.websockError; //监听服务器发送的消息
      this.websock.onmessage = this.websockMessage;
    },
    //重新连接
    reconnect () {
      let that = this;
      if (that.lockReconnect) {
        return;
      };
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(() => {
        //新连接
        that.init();
        that.lockReconnect = false;
      }, 5000);
    },
    reset () {//重置心跳
      let that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start () {//开启心跳
      let self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) {//如果连接正常
          console.log("心跳");
          self.websock.send("heartCheck");
        } else {//否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(() => {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout)
    },
    websockOpen () {
      // console.log('监听打开');
      //开启心跳
      this.start();
    },
    websockClose () {
      // console.log('监听关闭');
      this.reconnect();
    },
    websockError () {
      console.log('监听异常');
      //重连
      this.reconnect();
    },
    // 接收信息
    websockMessage (e) {
      console.log(e)
      let obj = JSON.parse(e.data)
      let arr = obj.msg.split(',')
      this.imgArr = arr;
      this.formItem.imgArr = arr;
      this.modal2 = false;
      //收到服务器信息，心跳重置
      this.reset();
      // 关闭websock
      // this.websock.onclose();
    },
  },
  created () {
    var session = JSON.parse(localStorage["session"]);
    this.session = session;
    this.fileCommonUrl = localStorage.getItem('fileCommonUrl')
    let goData = JSON.parse(window.sessionStorage.getItem('goData'))
    if (goData) {
      if (goData.title == '新增预申报') {
        this.pageTitle = '新增预申报';
      } else if (goData.title == '编辑预申报') {
        this.pageTitle = '编辑预申报';
        goData.row.executeDate = [];
        goData.row.executeDate.push(goData.row.setStartDateStr);
        goData.row.executeDate.push(goData.row.setEndDateStr);
        goData.row.pictrues.forEach(item => {
          this.imgArr.push(item.picPath);
        });
        goData.row.contNum = goData.row.contNum.toString();
        goData.row.orePrice = goData.row.orePrice.toString();
        this.formItem = goData.row;
        if (this.imgArr.length > 0) {
          this.imgArr.forEach(item => {
            this.formItem.imgArr = []
            this.formItem.imgArr.push(item)
          })
        }
      }
    }
    this.init()
    this.getGrantListNo();
    this.inquireEnterprise();
    this.getKuangArr()
    this.formItem.enterpriseId = this.session.enterpriseId;
  },
  mounted () {
    window.sessionStorage.setItem('from', 'grantList')
  },
  destroyed () {
    //关闭websock
    this.websock.onclose();
  },
  watch: {
    formItem: {
      handler: function (newVal) {
        if (newVal.contractNo != '' && newVal.oreId != '' && newVal.contNum != '' && newVal.orePrice != '' && newVal.enterpriseId !=
          '' && newVal.buyer != '' && newVal.startDir != '' && newVal.endDir != '' && newVal.executeDate[0] != '' &&
          newVal.imgArr.length != 0) {
          let next = document.querySelector('.submitBox');
          next.style.background = '#2C59C3';
          next.style.cursor = 'pointer'
        } else {
          let next = document.querySelector('.submitBox');
          next.style.backgroundImage = 'linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%)';
          next.style.cursor = 'default'
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.toastBox {
  // display: none;
  overflow-y: scroll;
  background-color: white;
  min-width: 384px;
  position: absolute;
  z-index: 999;
  top: 3px;
  left: 0px;
  height: 200px;
  padding: 10px 0;
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  p {
    padding: 0 10px;
  }
  p:hover {
    background: #f3f3f3;
  }
}
.titleColor {
  color: #ed4014;
}

/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.renderbox {
  background: #f5f7fa;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  min-height: 38px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-all;
}

.star {
  color: red;
  margin-right: 8px;
  position: relative;
  top: 2px;
}

.bgColor {
  background: #2c59c3 !important;
  color: white;
  opacity: 1 !important;
}

/deep/ .ivu-select-input {
  height: 48px;
  line-height: 48px;
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

/deep/ .ivu-modal-body {
  padding: 36px !important;
}

/deep/.ivu-modal-body .tabListBox {
  display: flex !important;
  border-bottom: 1px solid #e5e5e5;
}

/deep/.ivu-modal-body .tabListBox > div {
  border-radius: 8px 8px 0 0;
  width: 100px;
  height: 32px;
  opacity: 0.7;
  background: #e0e5f0;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}

.grantlist {
  width: 100%;
  background-color: rgb(254, 254, 254);

  header {
    width: 100%;
    height: 34px;

    div {
      width: 1200px;
      margin: 0 auto;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #616c84;
      letter-spacing: -0.43px;
    }
  }

  main {
    width: 1200px;
    margin: 0 auto;

    .titleBox {
      width: 1200px;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .titleBox_left {
        display: flex;
        align-items: center;

        span {
          margin-left: 18px;
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #252a37;
          letter-spacing: 0.39px;
        }
      }

      .titleBox_right {
        span {
          cursor: pointer;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #2c59c3;
          letter-spacing: 0.26px;
        }
      }
    }

    .mainBox {
      width: 1200px;
      // height: 1000px;
      padding-bottom: 81px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 2px 2px rgb(240, 240, 240);
      font-weight: 600;
      margin-bottom: 20px;
      margin-top: 8px;

      .main_title {
        width: 80%;
        margin: 0 auto;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        color: #2c59c3;
        letter-spacing: 0.36px;
        border-bottom: 1px solid #ebedf3;
        margin-bottom: 20px;
      }

      .successBox {
        width: 1200px;
        padding: 86px 0 0px 0px;
        box-sizing: border-box;

        .successBox_titleson {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 32px;

          span {
            margin-left: 16px;
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #4a4a4a;
            letter-spacing: 0.45px;
          }
        }

        .successBox_messageson {
          text-align: center;
          margin-bottom: 285px;

          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
          }
        }

        .threeBox {
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #878787;
          letter-spacing: 0;
          margin-bottom: 40px;
        }

        .returnBox {
          text-align: center;
        }
      }

      .formBox {
        width: 80%;
        margin: 0 auto;

        .contractBox {
          display: flex;
          align-items: center;
        }

        .photoBox {
          position: relative;

          .goPrev {
            position: absolute;
            left: -40px;
            top: 130px;
          }

          .goNext {
            position: absolute;
            right: -40px;
            top: 130px;
          }

          .photoBox_son1 {
            width: 208px;
            height: 271px;
            text-align: center;
            line-height: 271px;
            background: #ffffff;
            border: 1px solid #ccd1dd;
            border-radius: 4px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ced2db;
            letter-spacing: 0.25px;
          }

          .photoBox_son2 {
            width: 960px;
            height: 294px;
            // position: relative;
            overflow: hidden;

            .imgBox {
              display: flex;
              transform: translateX(0px);
              transition: transform 0.35s;

              .imgbg {
                position: relative;
                height: 294px;
                display: flex;
                justify-content: center;

                .imgbg_img {
                  width: 230px;
                  height: 294px;
                  margin-right: 10px;
                }
              }
            }
          }
        }

        .submitBox {
          width: 368px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          margin: 0 auto;
          background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
          border: 1px solid #b2c9ff;
          border-radius: 8px;
          color: white;
          cursor: pointer;
        }
      }
    }
  }
}

/deep/ .ivu-btn-primary {
  background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
  margin: 0 10px;
}

/deep/ .ivu-modal-header {
  background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  height: 48px;
}

/deep/ .ivu-modal-content {
  border-radius: 10px;
}

/deep/ .ivu-modal-close .ivu-icon-ios-close {
  color: white;
}

// 表单label样式
/deep/ .ivu-form .ivu-form-item-label {
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #616c84;
  letter-spacing: 0.26px;
  line-height: 20px;
}

.ivu-form-item {
  width: 368px;
}

/deep/.flex-between-center .ivu-input {
  height: 48px;
  box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
}

/deep/ .ivu-select-single .ivu-select-selection {
  height: 48px;
  line-height: 48px;
  box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
}

/deep/.ivu-select-selected-value {
  height: 48px;
  line-height: 48px;
}

/deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  line-height: 48px;
}

/deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 48px;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  line-height: 48px;
  height: 48px;
}

/deep/ .ivu-date-picker {
  display: block;
}

/deep/ .ivu-input-suffix {
  line-height: 48px;
}

/deep/.ivu-form .ivu-form-item-label {
  font-size: 14px;
  color: #b3b8c4;
  letter-spacing: 0.26px;
}

/deep/ .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  color: #515a6e;
}
/deep/ .ivu-input {
  padding-left: 10px;
}
</style>
